import { render, staticRenderFns } from "./ActionDialog.vue?vue&type=template&id=72b7c8b6&"
import script from "./ActionDialog.vue?vue&type=script&lang=js&"
export * from "./ActionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports